import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-export-data-dialogue",
    templateUrl: "./export-data-dialogue.component.html",
    styleUrls: ["./export-data-dialogue.component.scss"],
    standalone: false,
})
export class ExportDataDialogueComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
